import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../../../core/alert.service";

@Component({
  selector: 'app-invoice-notes',
  templateUrl: './invoice-notes.component.html',
  styleUrls: ['./invoice-notes.component.scss']
})
export class InvoiceNotesComponent implements OnInit {
  public notesInfo: string;

  constructor( private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private alert: AlertService) { }

  ngOnInit() {

  }

  saveNotes(dataInfo){
      if(dataInfo && dataInfo.trim().length > 0){
        //this.alert.alertSuccess({ title: 'Success', text : 'Thank you, payment process will continue...' });
        this.close(dataInfo);
      }else{
        this.alert.alertWarning({ title: 'Warning', text : 'Please provide additional Notes.' });
      }
  }

  close(data?: any) {
    this.activeModal.close(data);
  }

}
